import { useState } from "react";

export default function SearchingNavbar() {
    const [searchInput, setSearchInput] = useState('');


    const searchRequest = () => {

    };

    return (
        <nav className="MApp-toolbar bg-primary">
            <h1 className="text-white ps-5">MApp</h1>
            <div className="logo-2 ps-4 ms-4 mt-3">
                <h3 className="text-white">The Movie App</h3>
                <i className="fa-regular fa-map"></i>
            </div>
            {/* comment out the navbar for now since it makes the website looks unfinished if it doesn't work          */}
            {/* <div className="search-bar">
                <label className="me-1 text-white" htmlFor="">Search</label>
                <input className="search-box bg-dark text-white" type="text" onChange={(e) => setSearchInput(e.target.value)} onKeyUp={e => e.key === 'Enter' ? searchRequest() : null} />
            </div> */}
        </nav> 
    ) 
}